import {boardNames, colorsNames, deliveryNames, dimensionsNames, typeOptionsNames} from "./helpers/enums"
import React from "react";

export const typeOptions = [
    {label: "Prosty", icon: "", price: 270, key: typeOptionsNames.TYPE_P, image: require("./assets/types/straight.png")},
    {label: "Kształt L", icon: "", price: 270, key: typeOptionsNames.TYPE_L, image: require("./assets/types/right_angle.png")},
    {label: "Skośny", icon: "", price: 270, key: typeOptionsNames.TYPE_S, image: require("./assets/types/skew.png")}
]

export const dimensionsOptions = [
    {label: "Wymiar H (height)", minValue: 80, maxValue: 300, defaultValue: "150", unit: "mm", key: dimensionsNames.HEIGHT},
    {label: "Wymiar L (length)", minValue: 20, maxValue: 100, defaultValue: "50", unit: "mm", key: dimensionsNames.LENGTH},
    {label: "Wymiar W (width)", minValue: 40, maxValue: 110, defaultValue: "60", unit: "mm", key: dimensionsNames.WIDTH},
    {label: "Kąt nachylenia ⍺", minValue: 0, maxValue: 15, defaultValue: "0", unit: "°", key: dimensionsNames.TILT_ANGLE}
]

export const colorsOptions = [
    {label: "Anthracite grey", key: colorsNames.GRAY, valueRal: "7016"},
    {label: "Pure white", key: "white", valueRal: "9010"},
    {label: "Rape yellow", key: "yellow", valueRal: "1021"},
    {label: "Traffic blue", key: "blue", valueRal: "5017"},
    {label: "Moss green", key: "green", valueRal: "6005"},
    {label: "Traffic red", key: "red", valueRal: "3020"},
    {label: "Jet black", key: "black", valueRal: "9005"},
    {label: "Inny", key: colorsNames.OTHER, valueRal: "9001"},
]

export const  boardOptions = [
    {label: "Blat duży", key: boardNames.BIG, dimension: "305 x 305 mm z folią ochronną", price: 69},
    {label: "Blat mały", key: boardNames.SMALL, dimension: "255 x 255 mm z folią ochronną", price: 69},
    {label: "Bez blatu", key: boardNames.NONE, dimension: "", price: 0},
]

export const additionalPrices = {
    height: 15,
    lampHolder: 45,
    customColor: 49,
    spareFoil: 25
}

export const formsOfDelivery = [
    {label: "Odbiór osobisty", key: deliveryNames.PERSONAL_PICKUP, price: 0},
    {label: "Kurier", key: deliveryNames.COURIER, price: 20},
    {label: "Paczkomat", key: deliveryNames.PARCEL_LOCKER, price: 15}
]

export const countries = ["Polska","Czech Republic","Germany","Ukraine","United Kingdom","Afghanistan","Albania","Algeria","American Samoa","Andorra","Angola","Anguilla","Antarctica","Antigua And Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia And Herzegovina","Botswana","Bouvet Island","Brazil","British Indian Ocean Territory","Brunei Darussalam","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada","Cape Verde","Cayman Islands","Central African Republic","Chad","Chile","China","Christmas Island","Cocos (Keeling) Islands","Colombia","Comoros","Congo","Congo, The Democratic Republic Of The","Cook Islands","Costa Rica","Cote D'ivoire","Croatia","Cuba","Cyprus","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Ethiopia","Falkland Islands (Malvinas)","Faroe Islands","Fiji","Finland","France","French Guiana","French Polynesia","French Southern Territories","Gabon","Gambia","Georgia","Ghana","Gibraltar","Greece","Greenland","Grenada","Guadeloupe","Guam","Guatemala","Guernsey","Guinea","Guinea-bissau","Guyana","Haiti","Heard Island And Mcdonald Islands","Holy See (Vatican City State)","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran, Islamic Republic Of","Iraq","Ireland","Isle Of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Korea, Democratic People's Republic Of", "Korea, Republic Of Kuwait","Kyrgyzstan","Lao People's Democratic Republic","Latvia","Lebanon","Lesotho","Liberia","Libyan Arab Jamahiriya","Liechtenstein","Lithuania","Luxembourg","Macao","Macedonia"," The Former Yugoslav Republic Of","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Martinique","Mauritania","Mauritius","Mayotte","Mexico","Micronesia"," Federated States Of","Moldova"," Republic Of","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","Netherlands Antilles","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Niue","Norfolk Island","Northern Mariana Islands","Norway","Oman","Pakistan","Palau","Palestinian Territory, Occupied","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Pitcairn","Poland","Portugal","Puerto Rico","Qatar","Reunion","Romania","Russian Federation","Rwanda","Saint Helena","Saint Kitts And Nevis","Saint Lucia","Saint Pierre And Miquelon","Saint Vincent And The Grenadines","Samoa","San Marino","Sao Tome And Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Georgia And The South Sandwich Islands","Spain","Sri Lanka","Sudan","Suriname","Svalbard And Jan Mayen","Swaziland","Sweden","Switzerland","Syrian Arab Republic","Taiwan, Province Of China","Tajikistan","Tanzania, United Republic Of","Thailand","Timor-leste","Togo","Tokelau","Tonga","Trinidad And Tobago","Tunisia","Turkey","Turkmenistan","Turks And Caicos Islands","Tuvalu","Uganda","United Arab Emirates"," United States","United States Minor Outlying Islands","Uruguay","Uzbekistan","Vanuatu","Venezuela","Vietnam","Virgin Islands, British","Virgin Islands, U.S.","Wallis And Futuna","Western Sahara","Yemen","Zambia","Zimbabwe"]

export const tabs = [
    {name: "START", pathname:"/"},
    {name: "TECHNIKALIA", pathname:"/drawings"},
    {name: "KONFIGURATOR", pathname:"/configurator"},
    {name: "ZASADY", pathname:"/rules"},
    {name: "GALERIA", pathname:"/gallery"},
    {name: "KONTAKT", pathname:"/contact"}
]

export const homeContent = [
    {
        title: "CUSTOM MAP HOLDER",
        image: require("./assets/homeImages/generalOverview.png"),
        imageLeft: true,
        description: "To platforma dzięki której skonfigurujesz mapnik rowerowy według własnych wymagań w kliku prostych krokach.",
    },
    {
        title: "KSZTAŁT I KOLOR",
        image: require("./assets/homeImages/colorAndShape.png"),
        imageLeft: false,
        description: "Dostępne są 3 podstawowe kształty - prosty, skośny oraz kształt L. Do wyboru dostępnych jest 7 podstawowych kolorów. Opcjonalnie można wybrać własny kolor dostępny w palecie RAL. Jeśli potrzebujesz nietypowego kształtu wyślij zapytanie na e-mali.",
    },
    {
        title: "BUDOWA",
        image: require("./assets/homeImages/waterjet.png"),
        imageLeft: true,
        description: "Mapniki wykonane są z wytrzymałego stopu aluminium. Poszczególne detale wykonywane są na maszynach CNC. Całość jest malowana metodą proszkową na wybrany kolor.",
    },
    {
        title: "WYMIARY",
        image: require("./assets/homeImages/dimensions.png"),
        imageLeft: false,
        description: "Dobierz odpowiednią wysokość, szerokość mocowania, długość i kąt nachylenia. Dokładny sposób wymiarowania znajdziesz w zakładce TECHNIKALIA. Wszystkie mapniki przeznaczone są do kierownic o średnicy 31,8mm (1 1/4”). Możliwe są również nietypowe rozwiązania. ",
    },
    {
        title: "BLAT",
        image: require("./assets/homeImages/foto_board_1.png"),
        imageLeft: true,
        description: "Do wyboru są dwa rozmiary blatów – mały o wymiarach 255 x 255 mm oraz duży o wymiarach 305 x 305 mm. Folia ochronna mocowana jest do blatu za pomocą elastycznych gumek. Blat posiada 4 haki z tworzywa sztucznego pozwalające szybko i sprawnie zapiąć i odpiąć folię.",
    },
    {
        title: "DODATKI",
        image: require("./assets/homeImages/accessories.png"),
        imageLeft: false,
        description: "Do każdej z wersji można opcjonalnie dodać uchwyt na lampkę, duży lub mały blat oraz zapasową folię ochronną. Śruby nierdzewne do mocowania na kierownicy oraz mocowania blatu są w komplecie ze stelażem."
    },
]
export const typesDrawings = [
    {label: "Typ Prosty", title: typeOptionsNames.TYPE_P, image: require("./assets/drawingsImages/P_draw.PNG")},
    {label: "Typ Kształt L", title: typeOptionsNames.TYPE_L, image: require("./assets/drawingsImages/L_draw.PNG")},
    {label: "Typ Skośny", title: typeOptionsNames.TYPE_S, image: require("./assets/drawingsImages/S_draw.PNG")}
]

export const galleryContent = [
    {
        title: "board_1",
        image: require("./assets/galleryImages/photo1.jpg")
    },
    {
        title: "board_2",
        image: require("./assets/galleryImages/photo2.jpg")
    },
    {
        title: "board_3",
        image: require("./assets/galleryImages/photo3.jpg")
    }
]
